import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

const QueueWait = (props) => {
  const { loginId } = props;
  const { leaveQueue, position, estimatedWaitTime, setSeatShow, setListShow } =
    props.childProps;

  const unload = async () => {
    // console.log('SeatReserve unload.....');
    leaveQueue();
  };

  useEffect(() => {
    // document.oncontextmenu = function () {
    //   return false;
    // };

    window.addEventListener('beforeunload', unload);
    // window.addEventListener('unload', unload);
    return () => {
      // console.log('disconnect.......');
      leaveQueue();
      window.removeEventListener('beforeunload', unload);
    };
  }, []);

  return (
    <div className="queue-container">
      <div className="queue-info">
        <h2 className="">{loginId}님</h2>
        <h2>현재 동시 접속자가 많아 접속 대기 중입니다.</h2>

        <p className="queue-info-p">
          {position !== -1 ? (position + 1).toLocaleString('ko-KR') : '0'} 명이
          내 앞에 대기하고 있습니다.
        </p>
        {/* <p className="queue-info-p-1">예상 대기시간: {estimatedWaitTime}분</p> */}

        <p className="queue-notice">
          대기 순서에 따라 자동 접속되니 조금만 기다려 주세요
        </p>
        <p className="queue-notice">
          새로고침 또는 뒤로가기를 하시면 다시 대기시간이 부여됩니다.
        </p>
        <p className="queue-notice-1">
          * 최대 5분간 대기 숫자의 변동이 없다면 새로고침을 시도해 주세요.
        </p>
      </div>
      <div className="btn-box">
        <div className="btn-seat" onClick={() => setSeatShow(true)}>
          극장 좌석표{' '}
        </div>
        <div className="btn-info" onClick={() => setListShow(true)}>
          나의 예매정보{' '}
        </div>
      </div>
    </div>
  );
};

export default shopContext(withRouter(QueueWait));
